import {BasicsClass} from "@/common/BasicsClass";

export default class OperationRecordAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getOperationRecord', {
            url: '/operateRecord/list',
            name: 'opertaion-reacord-list',
            label: '操作记录列表'
        }],
    ])

    public getOperationRecord(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls
        const url = apiUrls.get('getOperationRecord').url
        this.BasicPost(
            url,
            {
                ...params,
            },
            false,
            false,
            false,
            successCb,
            failCb,
            showLoading
        );
    }
}